import { render, staticRenderFns } from "./gameDetail.vue?vue&type=template&id=42f62040&scoped=true"
import script from "./gameDetail.vue?vue&type=script&lang=js"
export * from "./gameDetail.vue?vue&type=script&lang=js"
import style0 from "./gameDetail.vue?vue&type=style&index=0&id=42f62040&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f62040",
  null
  
)

export default component.exports